// tslint:disable
export var NoteAggregateType;
(function (NoteAggregateType) {
    // User
    NoteAggregateType[NoteAggregateType["User"] = 0] = "User";
})(NoteAggregateType || (NoteAggregateType = {}));
NoteAggregateType['USER'] = 0;
//# sourceMappingURL=NoteAggregateType.js.map